import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import {
  ButtonModule,
  HrModule,
  MasterBannerModule,
  NavButtonModule,
  PreloaderModule,
  SvgIconModule
} from '@hdms/shared/ui-core';
import { AnalyticsModule, LetModule } from '@hdms/shared/util-core';

import { HeaderProductMenuLinksComponent } from './header-product-menu-links.component';
import { ViewCategoriesLinkComponent } from './view-categories-link.component';

@NgModule({
  declarations: [HeaderProductMenuLinksComponent, ViewCategoriesLinkComponent],
  imports: [
    CommonModule,
    NavButtonModule,
    AnalyticsModule,
    LetModule,
    HrModule,
    MasterBannerModule,
    PreloaderModule,
    SvgIconModule,
    TranslationModule,
    ButtonModule
  ],
  exports: [HeaderProductMenuLinksComponent, ViewCategoriesLinkComponent]
})
export class HeaderProductMenuLinksModule {}
